import {
  ethereum,
  ethereumClassic,
  ropsten,
  singularDTV,
  expanse,
  ubiq,
  ellaism,
  etherGem,
  callisto,
  ethereumSocial,
  musicoin,
  goChain,
  xdcnetwork,
  eosClassic,
  akroma,
  etherSocialNetwork,
  pirl,
  ether1,
  atheios,
  tomoChain,
  mixBlockchain,
  iolite,
  rskMainnet,
  rskTestnet,
  lightstreamsNetwork,
  ethercore
} from '../configs/configPaths';
export default [
  ethereum,
  ethereumClassic,
  ropsten,
  singularDTV,
  expanse,
  ubiq,
  ellaism,
  etherGem,
  callisto,
  ethereumSocial,
  musicoin,
  goChain,
  xdcnetwork,
  eosClassic,
  akroma,
  etherSocialNetwork,
  pirl,
  ether1,
  atheios,
  tomoChain,
  mixBlockchain,
  iolite,
  rskMainnet,
  rskTestnet,
  lightstreamsNetwork,
  ethercore
];
